<template>
  <div id="langl">
    <v-menu offset-y> 
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" title="">
          <v-icon>fa fa-globe-europe</v-icon>
          <span class="txt" style="color:#fff;">{{ $i18n.locale }}</span>
          <v-icon small>fa fa-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in langItems" :key="index">
          <v-list-item-title @click="selectLang(item.value)" class="cursor-pointer">{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { VMenu, VBtn, VIcon, VList, VListItem, VListItemTitle } from 'vuetify/lib';
import LanguageService from '@/services/LanguageService';
import LocalStorageService from "@/services/LocalStorageService";

export default {
  name: "LanguageSwitcher",
  components:{
    VMenu, VBtn, VIcon, VList, VListItem, VListItemTitle
  },
  data() {
    return {
      lang: this.$i18n.locale,
      langItems: [
        { value: "en", label: "English" },
        { value: "es", label: "Español" },
        { value: "fr", label: "Français" }
      ]
    };
  },
  methods: {
    selectLang(lang) {
      this.$i18n.locale = lang;
      LanguageService.postSetSession({ languageCode: lang, localeManual: 1 }).then((resp) => {
        if(resp.data.success) {
          this.$store.dispatch('setLanguageId', resp.data.message.id);
        }
        this.$store.dispatch('setLanguageCode', this.$i18n.locale);
        const lang1 = {
          id: this.$store.state.session.languageId,
          code: this.$i18n.locale
        };
        LocalStorageService.setItem("languagePart", lang1);
      });
    }
  },
  mounted() {
    LanguageService.getAvailable().then((resp) => {
      this.langItems = resp.data.map((item) => {
        return { value: item.languageCode, label: item.languageName };
      });
      this.$store.dispatch('setLanguages', resp.data);
      LanguageService.getCurrent().then((resp) => {
        if(resp.data) {
          this.$i18n.locale = resp.data.code;
          this.$store.dispatch('setLanguageId', resp.data.id);
          this.$store.dispatch('setLanguageCode', this.$i18n.locale);
        }
      });
    });
  }
};
</script>

<style>
@media (max-width: 699px) {
  #langl button{
    width: 12px;
    height: 36px;
  }
  #langl .txt{
    content: "";
    display: none;
  }
} 
.cursor-pointer {
  cursor: pointer;
}
</style>